<div class="app2 copyright" id="copyright">
  <div class="container">
    <div class="row">
      @defer(when copyrightText){
      <div class="col-12">
        <div class="center-content">
          <div class="d-flex gap-5 mb-3">
            <a class="text-white" href="https://www.instagram.com/fitup.ux/" target="_blank"><i
                class="fa-brands fa-instagram "></i></a>
            <a class="text-white" href="https://www.facebook.com/profile.php?id=61564914098380" target="_blank"><i
                class="fa-brands fa-square-facebook"></i></a>
            <a class="text-white" href="#"><i class="fa-brands fa-square-x-twitter"></i></a>
          </div>
          <div class="center-flex">

            @for (footer of footerTextLinks; track $index) {
            <ul class="footer-content">
              <li class="footer-text-link">
                <a [href]="footer.footerLink">
                  {{footer.footerText}}</a>
              </li>
            </ul>
            }
          </div>
          <div>
            <p class="copyright-text text-white">© {{year}}. {{copyrightText}}</p>
          </div>
        </div>
      </div>
      }@placeholder {
      <div class="col-12">
        <div class="center-content">
          <div class="d-flex gap-5 mb-3">
            <a><ngx-skeleton-loader [appearance]="'circle'"></ngx-skeleton-loader></a>
            <a><ngx-skeleton-loader [appearance]="'circle'"></ngx-skeleton-loader></a>
            <a><ngx-skeleton-loader [appearance]="'circle'"></ngx-skeleton-loader></a>
          </div>

          <div class="text-center">
            <div class="d-flex flex-row">
              <ngx-skeleton-loader count="1" appearance="line" [theme]="{width:'125px', marginRight:'1rem'}" />
              <ngx-skeleton-loader count="1" appearance="line" [theme]="{width:'125px', marginLeft:'1rem'}" />
            </div>
            <div>
              <ngx-skeleton-loader count="1" appearance="line" [theme]="{width:'150px', marginLeft:'auto'}" />
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
<app-tap-to-top></app-tap-to-top>